/**
 * Medical Board section functionality
 * Handles display when there are more than 2 team members
 */
(function() {
  'use strict';
  // Medical board JS - add carousel/slider functionality here if needed
})();
